/**
 * @desc IAB safeframe API for some limited functionality
 * {@link http://www.iab.net/media/file/SafeFrames_v1.1_final.pdf}
 */
import type { UpdateViewabilityData, ViewabilityStandard, ViewableInfo } from '@amzn/safe-frame-client-amzn';

let cachedPayload: ViewableInfo | null = null;

let cachedViewabilityStandards: ViewabilityStandard[] | null = null;

let cachedPlayingTime: number | null = null;

export interface SfViewableInfo {
    viewabilityStandards?(): ViewabilityStandard[];
    payload?(): ViewableInfo;
}

class SfViewableInfoImpl implements SfViewableInfo {
    /**
     * @desc [Internal & External] Gives the viewability standards of SafeFrame container
     */
    viewabilityStandards(): ViewabilityStandard[] {
        cachedViewabilityStandards = cachedViewabilityStandards || [];
        return cachedViewabilityStandards as ViewabilityStandard[];
    }
    /**
     * @desc [Internal & External] Gives the viewability payload of SafeFrame container
     * @returns {Object} ViewabilityPayload - cachedPayload
     */
    payload(): ViewableInfo {
        // TODO Fix this incosistency
        cachedPayload = cachedPayload || ({} as any); //This is probably a bug
        return cachedPayload as ViewableInfo;
    }
}

export const $sfViewableInfo: SfViewableInfo = new SfViewableInfoImpl();

interface PlayingTimeInfo {
    playingTime?: (() => number | null) | null;
}

/**
 * @desc Gives the playing time in seconds for a video creative
 * @returns {Number} cachedPlayingTime
 */
const $sfPlayingTimeInfo: PlayingTimeInfo = {
    playingTime: (): number => {
        cachedPlayingTime = cachedPlayingTime || 0;
        return cachedPlayingTime;
    },
};

export const produceViewableInfo = (): SfViewableInfo => {
    return $sfViewableInfo;
};

export const producePlayingTimeInfo = (): PlayingTimeInfo => {
    return $sfPlayingTimeInfo;
};

export const update = (data: UpdateViewabilityData) => {
    cachedPayload = data?.payload !== undefined ? data?.payload : null;
    if (cachedPayload === null) {
        // Problem determining payload remove functions that expose it
        delete $sfViewableInfo.payload;
    }
    cachedViewabilityStandards = data?.viewabilityStandards !== undefined ? data?.viewabilityStandards : null;
    if (cachedViewabilityStandards === null) {
        // Problem determining viewabilityStandards remove functions that expose it
        delete $sfViewableInfo.viewabilityStandards;
    }
};

export const updatePlayingTime = (playingTime: number) => {
    cachedPlayingTime = playingTime;
    if (cachedPlayingTime === null) {
        // Problem determining playingTime remove functions that expose it
        delete $sfPlayingTimeInfo.playingTime;
    }
};
